<template>
<div class="alertDateSoon row">
    <img src="https://preprod.api.defipix.fr/logos/close_200.png" class="closeBtn" @click="close" />
    <h4 class="font-weight-bold col-12">hoho...<i v-if="!noEmojis" class="em em-see_no_evil" aria-role="presentation" aria-label="SEE-NO-EVIL MONKEY"/></h4>
    <p>Votre événement a lieu dans très peu de temps !</p>
    <p>Contactez-nous directement par téléphone pour organiser ça !</p>
    <h5 class="tel">01 64 19 80 64</h5>
</div>
</template>

<script>

export default {
    data() {
        return {
            noEmojis: this.$store.getters.reservation_client.noEmojis,
        }
    },
    methods: {
        close: function() {
            this.$parent.alertDateSoon = false;
        }
    }
}
</script>

<style scoped>
h5, h4, p {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}

.alertDateSoon {
    max-width: 30em;
    height: fit-content;
    z-index: 1;
    position: fixed;
    top: 1em;
    left: 1em;
    right: 1em;
    bottom: 1em;
    margin: auto;
    background-color: rgb(248, 248, 248);
    box-shadow: 0px 0px 5px 0px #105588;
    border-radius: 5px;
    overflow: auto;
    padding: 2em;
}

.submit {
    display: block;
    margin: 1em auto 0 auto;
    padding: 1em;
    border-radius: 5px;
    border: none;
    background-color: #25327B;
    color: white;
}

.tel {
    color: #f677c4;
    font-weight: bold;
    text-align: center;
    display: block;
    margin: auto;
}

.closeBtn {
    width: 1em;
    position: absolute;
    top: 1em;
    right: 1em;
    cursor: pointer;
}

@media screen and (max-width: 650px) {

}
</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/AlertDateSoon.vue